import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

// Función optimizada para inicialización no bloqueante
const initializeApp = () => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  
  // Usar concurrent features para mejor rendimiento
  root.render(
    <BrowserRouter>
      <App />
    </BrowserRouter>
  );
};

// Función para cargar reportWebVitals de forma no bloqueante
const loadWebVitals = () => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      import('./reportWebVitals').then(({ default: reportWebVitals }) => {
        reportWebVitals();
      });
    }, { timeout: 3000 });
  } else {
    setTimeout(() => {
      import('./reportWebVitals').then(({ default: reportWebVitals }) => {
        reportWebVitals();
      });
    }, 3000);
  }
};

// Inicializar la aplicación
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp);
} else {
  initializeApp();
}

// Cargar Web Vitals de forma no bloqueante
loadWebVitals();
